import React from "react";
import logo from "./logo.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import "./App.css";
import localConfig from "local-storage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import $ from "jquery";
import { set } from "local-storage";

const server = require("./lib/server");
const myLib = require("./lib/MyLib");

function App() {
  const [state, setState] = React.useState({
    Logged: false, //trang thai dang nhap
    User: {
      JWT: localConfig.get("jwt"),
    },
  });
  const [connection, setConnection] = React.useState(null); //signlar
  var jwt = window.sessionStorage.getItem("JWT");
  if (myLib.toString(jwt) === "" && localConfig.get("jwt") !== undefined) {
    window.sessionStorage.setItem("JWT", localConfig.get("jwt"));
  }
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    // Update the document title using the browser API
    if (global.checkUser === undefined) {
      global.checkUser = true;
      server
        .query("user/get")
        .then((response) => {
          response.Quyen = JSON.parse(response.Quyen);
          global.User = response;
          setState({ Logged: true, User: response, loading: false });
        })
        .catch((error) => {
          console.log(error);
          setState({ loading: false, Logged: false, User: {} });
        });
    }
  });
  document.body.style.height = "100% !important";
  return state.Logged ? (
    <HomePage
      user={state.User}
      onExit={() => setState({ Logged: false, User: {} })}
    />
  ) : (
    <LoginPage
      onLogged={(state, user) => {
        window.sessionStorage.setItem("JWT", user.JWT);
        localConfig.set("jwt", user.JWT);
        global.User = user;
        setState({
          Logged: state,
          User: user,
        });
      }}
    />
  );
}

export default App;
